import endSearchSessionRequest from 'owa-service/lib/factory/endSearchSessionRequest';
import endSearchSessionOperation from 'owa-service/lib/operation/endSearchSessionOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export default function endSearchSessionService(sessionGuid: string) {
    endSearchSessionOperation({
        Header: getJsonRequestHeader(),
        Body: endSearchSessionRequest({
            SearchSessionId: sessionGuid,
        }),
    });
}
